import { COMMANDS, CONTAINER_ID, LOGIC } from "./constants";
export class EmarsysManager {
  static uuid = "";

  static setCustomerId(uuid) {
    this.uuid = uuid;
  }

  static addCustomerId() {
    if(this.uuid) this.push([COMMANDS.SET_CUSTOMER_ID, this.uuid]);
  }

  static addCart(items) {
    const cart = this.parsedItemsList(items);
    this.push([COMMANDS.CART, cart]);
  }

  static addSearchTerm(searchTerm) {
    this.push([COMMANDS.SEARCH_TERM, searchTerm]);
  }

  static addView(item_id) {
    this.push([COMMANDS.VIEW, item_id]);
  }

  static addCategory(category) {
    this.push([COMMANDS.CATEGORY, category]);
  }

  static addPurchase(transactionId, items) {
    this.push([
      COMMANDS.PURCHASE,
      {
        orderId: transactionId,
        items: this.parsedItemsList(items),
      },
    ]);
  }



  static formatProducts(products) {
    const arr = [];
    for (const product of products) {
        arr.push({
            id: product.item ?? product.id,
            title: product.title,
            imagePath: product.image,
            link: product.link,
            price_after_discount: product.price != null ? String(product.price) : null,
            price_before_discount: product.msrp != null ? String(product.msrp) : null,
            benefitType: product.c_benefit_type,
            small_text: product.c_bottom_cube_text ?? product.c_benefit_text_describe,
            value: product.c_benefit_value ?? product.c_benefit_text_describe ?? product.c_bottom_cube_text,
        });
    }
    return arr;
}

  static recommend(options) {
    return new Promise((resolve, reject) => {
      this.push([
        COMMANDS.RECOMMEND,
        {
          ...options,
          success: (sc, render) => {
            try {
              if (typeof options?.success === "function") {
                options.success(sc, render);
              }
              const products = this.formatProducts(sc?.page?.products || []);
              resolve(products);
            } catch (error) {
              resolve(null);
            }
          },
        },
      ]);

      this.go()
    });
  }

  static go() {
    this.push([COMMANDS.GO]);
  }

  static parsedItemsList(itemsList) {
    return (
      itemsList?.map((_item) => ({
        item: _item.item_id,
        price: _item.price,
        quantity: _item.quantity,
      })) || []
    );
  }

  static push(event) {
    if (window?.ScarabQueue?.push) {
      try {
        window.ScarabQueue.push(event);
      } catch (error) {
        console.error(error);
      }
    }
  }

  static emarsysAddToCart(itemsList) {
    this.addCustomerId();
    this.addCart(itemsList);
    this.go();
  }


  static trackItemView(item) {
    this.addCustomerId();
    this.addCart();
    this.addView(item.item_id);
    this.go();
  }

  static trackPurchase(itemsList, transactionId) {
    this.addCustomerId();
    this.addCart(itemsList);
    this.addPurchase(transactionId, itemsList);
    this.go();
  }

  static emarsysSearchTerm(term) {
    this.addCustomerId();
    this.addCart();
    this.addSearchTerm(term);
    this.go();
  }
  static emarsysHomeRecommendation(itemsList) {
    this.addCustomerId();
    this.addCart(itemsList);
    this.recommend({
      logic: LOGIC.CART,
      containerId: CONTAINER_ID.PERSONAL_RECS,
    });

    this.go();
  }

  static emarsysRelatedRecommendation(item_id) {
    this.addCustomerId();
    this.addView(item_id);
    return this.recommend({
      logic: LOGIC.RELATED,
      containerId: CONTAINER_ID.CATEGORY_RECS,
      limit: "8",
    }).then((sc) => {
      return {
        benefits: sc,
        btnText: 'אינדקס המלצות',
        title: 'הטבות מומלצות'
      };
    })
  }


  static emarsysCartRecommendation(itemsList) {
    this.addCustomerId();
    return this.recommend({
      logic: LOGIC.CART,
      containerId: CONTAINER_ID.CART_RECS,
      limit: "8",
    }).then((sc) => {
      return {
        benefits: sc,
        btnText: 'אינדקס המלצות',
        title: 'הטבות מומלצות'
      }
    })
  }

  static emarsysCategoryRecommendation(categoryTitle) {
    this.addCustomerId();
    this.addCategory(categoryTitle);
    this.addCart([]);
    return this.recommend({
      logic: LOGIC.CATEGORY,
      containerId: CONTAINER_ID.CATEGORY_RECS,
      limit: "8",
    }).then((sc) => {
      return {
        benefits: sc,
        btnText: 'אינדקס המלצות',
        title: 'הטבות מומלצות'
      }
    })
  }


  static emarsysSearchRecommendation(searchTerm) {
    this.addCustomerId();
    this.addCart();

    this.addSearchTerm(searchTerm);

    this.go();
  }

  static emarsysCatergorySelected(categoryTitle) {
    this.addCustomerId();
    this.addCart();

    this.addCategory(categoryTitle);
    this.go();
  }

  //DEPARTMENT

  static emarsysAlsoBoughtRecommendation(item_id) {
    this.addCustomerId();
    this.addCart();
    this.addView(item_id);

    return this.recommend({
      logic: LOGIC.ALSO_BOUGHT,
      containerId: CONTAINER_ID.ALSO_BOUGHT_RECS,
      limit: "8",
    }).then((sc) => {
      return {
        benefits: sc,
        btnText: 'אינדקס המלצות',
        title: 'הטבות מומלצות'
      };
    })
  }


  static emarsysPersonalRecommendation() {
    this.addCustomerId();

    return this.recommend({
      logic: LOGIC.PERSONAL,
      containerId: CONTAINER_ID.PERSONAL_RECS,
      limit: "8",
    }).then((sc) => {
      return {
        benefits: sc,
        btnText: 'אינדקס המלצות',
        title: 'הטבות מומלצות אישית'
      }
    })
  }

  static emarsysPopularItemsInCategory(categoryTitle) {
    this.addCustomerId();
    this.addCategory(categoryTitle);
   return  this.recommend({
      logic: LOGIC.POPULAR,
      containerId: CONTAINER_ID.POPULAR_RECS,
      limit: "8",
    }).then((sc) => {
      return {
        benefits: sc,
        btnText: 'אינדקס המלצות',
        title: 'הטבות מומלצות'
      }
    })
  }

}
